import React from 'react';
import CaseList from '../CaseList';
// @ts-ignore
import styles from './../CaseList.module.scss';
import useCases from '../../../Hooks/useCases';
import {
	useLazyCasesAssignedQuery,
	useLazyWorkplaceCasesArchivedQuery,
} from '../../../../../graphql/graphql';
import CloasedCasesFilter from './ClosedCasesFilter';
import ClosedCasesListItem from './ClosedCasesListItem';
import useFlatData from '../../../../Base/Hooks/useFlatData';
import { useAppContext } from '../../../../../Services/AppContext';

const ClosedCasesList: React.FC = () => {
	const { workplaceId } = useAppContext();
	const [getWorkplaceCasesQuery, { data, isLoading }] =
		useLazyWorkplaceCasesArchivedQuery();
	const { getWorkplaceCases, getNextPage, page, setPage } = useCases(
		getWorkplaceCasesQuery,
	);
	const { flatData, hasMoreData, loadData, setFilter } = useFlatData(
		getWorkplaceCases,
		{
			data: data?.workplaceCasesArchived?.data,
			totalPages: data?.workplaceCasesArchived?.meta?.totalPages,
			page: data?.workplaceCasesArchived?.meta?.page,
		},
		page,
		setPage,
		{
			workplaceId,
		},
	);

	return (
		<div className={styles.wrapper}>
			<CloasedCasesFilter
				onFilter={filter => setFilter(filter)}
				dataCount={data?.workplaceCasesArchived?.meta?.count}
			/>
			<CaseList
				flatData={flatData}
				onLoadMore={getNextPage}
				onRefresh={() => loadData(true)}
				isLoading={isLoading}
				hasMoreData={hasMoreData}
				renderItem={item => <ClosedCasesListItem item={item} />}
			/>
		</div>
	);
};

export default ClosedCasesList;
